// 구매옵션 재매칭 저장 시 「구매불가 → 구매취소」 대상 판정.
// 재매칭으로 옵션만 바꾼 행은 대상이 아니다 — 구매재고가 '구매불가' 로 표시된 행만.
export function pickUnbuyableRows (rows) {
  return (rows || []).filter(e => e && e.구매재고 === '구매불가')
}

export function describeRow (e) {
  const opt = [e.옵션1_중국어, e.옵션2_중국어].filter(Boolean).join(' / ')
  return `· ${e.상품명 || '-'} | ${opt || '-'} | x${e.구매요청수량 || 1}`
}

// 확인창에 보여 줄 목록(최대 max 건, 나머지는 외 N건)
export function describeRows (rows, max = 15) {
  const lines = rows.slice(0, max).map(describeRow)
  if (rows.length > max) lines.push(`· 另 (외) ${rows.length - max}件`)
  return lines.join('\n')
}
